import type { SceneObject } from './spatial';

/**
 * What a click on `id` selects: the outermost group around it, unless the user entered a group (double-click), in
 * which case the child of that group on the path to `id`. Sections never capture clicks.
 */
export function selectionTarget(objs: ReadonlyMap<string, SceneObject>, id: string, entered: string | null): string {
  const path: string[] = [id]; // id, then its ancestors
  for (let p = objs.get(id)?.parentId ?? null; p !== null && !path.includes(p); p = objs.get(p)?.parentId ?? null) path.push(p);
  const stop = entered === null ? path.length : path.indexOf(entered);
  // Ancestors below the entered group (or all of them when none is entered, or when id is outside it).
  const candidates = path.slice(0, stop < 0 ? path.length : stop);
  for (let i = candidates.length - 1; i >= 1; i--) if (objs.get(candidates[i]!)?.type === 'group') return candidates[i]!;
  return id;
}
